import CompanyDetails from "@components/CompanyDetails"
import { SiteShell } from "@components/SiteShell"
import { companyPageQueryOptions } from "@data/publicPageDataQuery"
import type { CompanyPageData } from "@site-types/publicPageData"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { isSupportedLocale } from "@utils/locale"
import { localizedRouteHead } from "@utils/routeHead"

export const Route = createFileRoute("/$locale/company")({
  beforeLoad: ({ params }) => {
    if (!isSupportedLocale(params.locale)) throw redirect({ to: "/404" })
  },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(companyPageQueryOptions(params.locale as "en" | "ja")),
  head: ({ params }) => {
    const locale = params.locale as "en" | "ja"
    return localizedRouteHead({ locale, page: "company", path: `/${locale}/company` })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const data = Route.useLoaderData()
  return (
    <SiteShell>
      <CompanyPage data={data} />
    </SiteShell>
  )
}

export function CompanyPage({ data }: { data: CompanyPageData }) {
  return <CompanyDetails data={data} />
}
